<template>
  <vs-tabs :value="0">
    <vs-tab label="학교 등록" @click="onClickTab(0)">
      <div>
        <search-nav @handleSearch="handleSearch">
          <search-nav-item-select :label="$t('search.검색조건')" v-model="nav.searchType" :list="nav.searchTypes" />
          <search-nav-item-field label="" v-model="nav.keyword" @keyupEvent="handleInput" />
        </search-nav>

        <div class="flex mb-4" style="justify-content: flex-end">
          <vs-button class="" color="secondary" @click="onClickNew"> 신규작성 </vs-button>
        </div>
        <vs-card>
          <vs-table stripe ref="table" :sst="true" :max-items="table.perPage" :data="table.list" :noDataText="$t('approval.결재문서가 없습니다')" @selected="handleItemClickDetail">
            <template slot="thead">
              <vs-th style="min-width: 130px"><span class="w-full text-center">No.</span></vs-th>
              <vs-th style="min-width: 130px"><span class="w-full text-center">학교 구분</span></vs-th>
              <vs-th style="min-width: 130px"><span class="w-full text-center">학교명</span></vs-th>
              <vs-th style="min-width: 130px"><span class="w-full text-center">학교장</span></vs-th>
              <vs-th style="min-width: 130px"><span class="w-full text-center">행정실장</span></vs-th>
              <vs-th style="min-width: 130px"><span class="w-full text-center">학교 담당자</span></vs-th>
              <vs-th style="min-width: 130px"><span class="w-full text-center">안전점검기관명</span></vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td class="text-center">{{ tr.id }}</vs-td>
                <vs-td class="text-center">{{ !!tr.facility_category_id ? tr.facility_category.cat3 : "-" }}</vs-td>
                <vs-td class="text-center">{{ !!tr.field_name ? tr.field_name : "-" }}</vs-td>
                <vs-td class="text-center">{{ !!tr.director_name ? tr.director_name : "-" }}</vs-td>
                <vs-td class="text-center">{{ !!tr.meta.행정실장 ? tr.meta.행정실장 : "-" }}</vs-td>
                <vs-td class="text-center">{{ !!tr.meta.학교담당자 ? tr.meta.학교담당자 : "-" }}</vs-td>
                <vs-td class="text-center">{{ !!tr.meta.companyTypes ? tr.meta.companyTypes.join(", ") : "-" }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>

          <div class="vs-con-table">
            <div class="con-pagination-table vs-table--pagination">
              <k-pagination :total="lastPage ? lastPage : 1" v-model="currentPage" @change="handleChangePage"></k-pagination>
            </div>
          </div>
        </vs-card>
      </div>
    </vs-tab>
    <vs-tab label="학교 현황" @click="onClickTab(1)"></vs-tab>
  </vs-tabs>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import SearchNavItemField from "@/components/nav/SearchNavItemField";
import KPagination from "@/components/kPagination/kPagination";
export default {
  name: "FieldWarehouseList",
  components: {
    SearchNav,
    SearchNavItemSelect,
    SearchNavItemField,
    KPagination,
  },
  filters: {
    comma(str) {
      return `${str}`.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  data() {
    return {
      // 검색 네비게이션
      nav: {
        searchTypes: [
          { text: "학교 구분", value: "cat3Name" },
          { text: "학교명", value: "field_name" },
          { text: "학교장", value: "director_name" },
          { text: "행정실장", value: "행정실장" },
          { text: "학교 담당자", value: "학교담당자" },
          { text: "안전점검기관", value: "companyTypes" },
        ],
        searchType: "",
        keyword: "",
      },

      currentPage: 1,
      lastPage: 1,
      total: 0,
      table: {
        list: [],
        perPage: 7,
        keyword: "",
      },

      // 마지막 api 호출시 사용한 옵션
      apiLastLoadOptions: null,
    };
  },
  created() {
    this.initBreadcrumb();
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
  },
  mounted() {
    this.loadFieldList();
  },
  methods: {
    initBreadcrumb() {
      this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "학교 현황" }, { title: "학교", active: true }]);
    },
    async loadFieldList() {
      const projectId = this.projectId;
      const page = this.currentPage;
      const perPage = this.table.perPage;

      const options = { projectId, code: "school", page, perPage };

      if (this.nav.searchType === "field_name") {
        options.keyword = this.nav.keyword;
      } else if (!!this.nav.searchType) {
        options.metaKey = this.nav.searchType;
        options.metaValue = this.nav.keyword;
      }

      if (JSON.stringify(options) === JSON.stringify(this.apiLastLoadOptions)) {
        // 이전과 동일한 옵션으로 리스트를 불러옵니다.
        return;
      }
      this.apiLastLoadOptions = JSON.parse(JSON.stringify(options));
      await this.$store.dispatch("project/LOAD_FIELD_LIST", options);
      const fieldListInfo = this.$store.state.project.fieldListInfo;

      this.table.list = fieldListInfo.data.map((item) => {
        return { ...item, meta: JSON.parse(item.meta) };
      });

      this.currentPage = fieldListInfo.current_page;
      this.lastPage = fieldListInfo.last_page;
      this.total = fieldListInfo.total;
    },
    onClickTab(tabIndex) {
      if (tabIndex === 0) {
        this.$router.push({ name: "field-school-list" });
      } else if (tabIndex === 1) {
        this.$router.push({ name: "field-school-info" });
      }
    },
    onClickSearch() {
      this.loadList();
    },
    onClickSort(sortKey, asc) {
      this.sortKey = sortKey;
      this.asc = asc;
    },
    onChangePage(page) {
      this.page = page;
    },
    onClickDownload() {
      this.popup.excel = true;
    },
    onClickNew() {
      this.$router.push({ name: "field-school-create" });
    },
    onClickClose() {
      const keys = Object.keys(this.popup);
      keys.map((key) => {
        this.popup[key] = false;
      });
    },
    handleItemClickDetail(data) {
      this.$router.push({ name: "field-school-update", params: { proj_id: this.$route.params.proj_id, postId: data.id } });
    },

    handleChangePage(page) {
      this.currentPage = page;
      this.loadFieldList();
    },
    // 사업장 검색 폼에서 Enter 키가 눌렸을 때
    handleInput(data) {
      this.nav.keyword = data;
      this.handleSearch();
    },
    // "검색" 버튼이 클릭됐을 때
    handleSearch() {
      this.loadFieldList();
    },
    jsonParse(str) {
      return JSON.parse(str);
    },
    totalNumDevices(data) {
      // 오브젝트의 value를 전부 합한 값을 리턴
      let sum = 0;
      for (let key in data) {
        sum += data[key];
      }
      return sum;
    },
  },
};
</script>

<style scoped></style>
